import { AMAP_KEY, AMAP_VERSION } from '../../config'

function buildScriptTag(src: string) {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.defer = true;
    script.src = src;
    return script;
}

export function loadMain() {
    if (window.AMap) {
        return Promise.resolve();
    }
    const script = buildScriptTag(`//webapi.amap.com/maps?v=${AMAP_VERSION}&key=${AMAP_KEY}&callback=__amap_init_callback`);
    const p = new Promise(resolve => {
        window['__amap_init_callback'] = () => {
            resolve(true);
            delete window["__amap_init_callback"];
        }
    });
    document.body.appendChild(script);
    return p;
}

export function loadMapui() {
    if (window.AMapUI) {
        return Promise.resolve()
    }
    const script = buildScriptTag(`//webapi.amap.com/ui/1.0/main-async.js`)
    const p = new Promise(resolve => {
        script.onload = () => {
            if (window.initAMapUI) {
                window.initAMapUI();
            }
            resolve(true)
        }
    })
    document.body.appendChild(script)
    return p
}